<template>
  <el-form :model="form" ref="form" :rules="rules" label-width="100px" class="form">
    <el-form-item label="用户名称" prop="name">
      <el-input v-model.number="form.name"></el-input>
    </el-form-item>
    <el-form-item label="权限说明" prop="role">
      <el-input v-model.number="form.role"></el-input>
    </el-form-item>
    <!-- <el-form-item>
      <el-button type="primary" @click="submitForm('form')">提交</el-button>
      <el-button @click="resetForm('form')">重置</el-button>
    </el-form-item> -->
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '普通管理员',
        role: '管理员具有平台全部功能使用权限。请谨慎配置。',
      },
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        role: [{ required: true, message: '请输入权限说明', trigger: 'change' }],
      },
    };
  },
};
</script>

<style lang="less" scped>
.form {
  padding: 20px 10px;
  .el-input {
    width: 600px;
  }
}
</style>
